"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PpuAddressCms = void 0;
var PpuAddressCms = /** @class */ (function () {
    function PpuAddressCms() {
        this.textTitle = "Address where you'll use it most";
        this.txtTitleToolTip = 'Your place of primary use should be a valid physical street address where you\'ll use your phone' +
            ' the most. This will be used to calculate the taxes on your monthly service. It\'s defaulted to' +
            ' your billing address unless you change it.';
        this.txtTitleToolTipBsse = "Your place of primary use is the address where you'll use your phone the most. We'll use it to calculate the taxes on your monthly service. It's defaulted to your billing address, but you can change it later by signing in to your myAT&T account.";
        this.phoneEdit = 'Edit';
        this.editAriaLabel = 'Edit place for primary use';
        this.askAddressDescription = 'Please provide us your place of primary use address.';
        this.ppuTaxText = "Tell us where you'll use this device the most. We'll use your address to calculate the taxes on your monthly service.";
        this.ppuNext = 'Next';
        this.ppuTitle = 'Place of primary use';
        this.ppuAddressDescription = "Tell us where you'll use this device the most. We'll use your address to calculate the taxes on your monthly service.";
    }
    return PpuAddressCms;
}());
exports.PpuAddressCms = PpuAddressCms;
//# sourceMappingURL=PpuAddress.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/PpuAddress/PpuAddress.cms.js
// module id = 2009
// module chunks = 8